import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useEffect } from 'react';

export default function About() {
  useEffect(() => {
    document.title = '关于我们 - 91浏览器官方 | 91浏览器';
    window.scrollTo(0, 0);
  }, []);

  const milestones = [
    { year: '2018', event: '91浏览器项目正式立项，核心团队组建完成' },
    { year: '2019', event: '发布v1.0版本，上线Android平台，获得首批10万用户' },
    { year: '2020', event: '用户突破500万，推出iOS版本，实现双平台覆盖' },
    { year: '2021', event: '发布v5.0大版本，引入隐私保护体系，用户突破2000万' },
    { year: '2022', event: '推出多标签管理、数据同步等重磅功能，获年度最佳工具应用提名' },
    { year: '2023', event: '全球用户突破4000万，月活跃用户超2500万' },
    { year: '2024', event: '发布v7.0版本，全面升级UI设计，引入AI智能功能' },
    { year: '2025', event: '用户突破5000万，推出智能翻译、下载管理等新功能' },
    { year: '2026', event: '发布v8.0版本，性能大幅提升，持续引领移动浏览器创新' },
  ];

  const reviews = [
    {
      name: '张先生',
      role: '互联网从业者',
      comment: '用了91浏览器两年多了，最满意的就是它的隐私保护功能。广告拦截很干净，浏览体验比系统自带的好太多。',
      rating: 5,
    },
    {
      name: '李女士',
      role: '大学生',
      comment: '多标签管理功能太方便了！做课题研究的时候能同时打开十几个网页，分组管理让一切井井有条，效率提升明显。',
      rating: 5,
    },
    {
      name: '王先生',
      role: '自由职业者',
      comment: '翻译功能是我的日常刚需，91浏览器的网页翻译准确度很高，看外文资料完全够用了，省去了来回切换翻译软件的麻烦。',
      rating: 4,
    },
    {
      name: '赵女士',
      role: '自媒体运营',
      comment: '下载管理功能太好用了，视频嗅探下载速度很快，断点续传也很稳定。数据同步让我在手机和平板间无缝切换。',
      rating: 5,
    },
    {
      name: '陈先生',
      role: '产品经理',
      comment: '作为对产品有要求的人，91浏览器的交互设计让我很舒服。界面简洁不花哨，操作逻辑清晰，是一款用心做的产品。',
      rating: 5,
    },
    {
      name: '刘女士',
      role: '高中教师',
      comment: '夜间模式配合定时切换太贴心了，晚上备课查资料眼睛不会那么累。数据节省模式也帮我省了不少流量。',
      rating: 4,
    },
  ];

  return (
    <>
      <Navbar />
      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
            <nav className="flex items-center gap-2 text-sm text-foreground-500" aria-label="面包屑导航">
              <a href="/" className="hover:text-primary-600 transition-colors">首页</a>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-900 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Intro */}
        <section className="py-20 md:py-28 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-4">
                  品牌介绍
                </span>
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6">
                  关于91浏览器
                </h1>
                <div className="space-y-4 text-foreground-600 leading-relaxed">
                  <p>
                    91浏览器创立于2018年，总部位于北京，是一家专注于移动浏览器研发的科技公司。我们致力于为全球用户提供<strong>安全、快速、智能</strong>的移动浏览体验。
                  </p>
                  <p>
                    经过多年的技术积累，91浏览器已发展成为拥有<strong>超过5000万用户</strong>的移动浏览器品牌，产品覆盖Android和iOS两大平台，在应用商店保持4.8分的高评分。
                  </p>
                  <p>
                    我们的核心理念是<strong>"用户隐私至上"</strong>——从产品设计的第一天起，隐私保护就根植于我们的DNA中。我们不追踪用户、不出售数据、不植入恶意广告，让每一次浏览都安心自在。
                  </p>
                  <p>
                    91浏览器团队由一群热爱技术、追求极致的工程师和设计师组成，我们相信好的产品应该让用户感到简单、自然、愉悦。未来，我们将继续在AI智能、隐私安全、浏览效率等方向持续创新。
                  </p>
                </div>
              </div>
              <div className="relative rounded-3xl overflow-hidden h-80 lg:h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20tech%20office%20workspace%20with%20collaborative%20team%20working%20on%20digital%20products%2C%20warm%20natural%20lighting%20through%20large%20windows%2C%20minimalist%20interior%20design%2C%20creative%20atmosphere%2C%20clean%20aesthetic%20professional%20environment&width=800&height=600&seq=about-brand&orientation=landscape"
                  alt="91浏览器团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="py-20 md:py-28 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-sm font-medium mb-3">
                发展历程
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                我们的成长足迹
              </h2>
            </div>
            <div className="relative">
              <div className="absolute left-4 lg:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2"></div>
              <div className="space-y-8">
                {milestones.map((m, idx) => (
                  <div
                    key={idx}
                    className={`relative flex items-start gap-6 ${
                      idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                    }`}
                  >
                    <div className="hidden lg:block flex-1"></div>
                    <div className="relative z-10 w-8 h-8 flex-shrink-0 rounded-full bg-primary-500 flex items-center justify-center">
                      <div className="w-3 h-3 rounded-full bg-background-50"></div>
                    </div>
                    <div className="flex-1 bg-background-50 rounded-xl p-5 border border-background-200/70">
                      <span className="inline-block px-2.5 py-0.5 bg-primary-100 text-primary-700 rounded-md text-xs font-semibold mb-2">
                        {m.year}
                      </span>
                      <p className="text-sm text-foreground-700 leading-relaxed">{m.event}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reviews */}
        <section className="py-20 md:py-28 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-sm font-medium mb-3">
                用户口碑
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
                听听用户怎么说
              </h2>
              <p className="text-foreground-500">来自真实用户的评价</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {reviews.map((review, idx) => (
                <div
                  key={idx}
                  className="bg-background-100 rounded-2xl p-6 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${
                          i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "{review.comment}"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-sm font-semibold text-primary-700">
                        {review.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-20 md:py-28 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-3">
                联系我们
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                与我们取得联系
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="text-center p-8 bg-background-50 rounded-2xl border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">电子邮箱</h3>
                <p className="text-sm text-foreground-500">support@91browser.com</p>
                <p className="text-xs text-foreground-400 mt-1">技术支持与合作咨询</p>
              </div>
              <div className="text-center p-8 bg-background-50 rounded-2xl border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-phone-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">客服热线</h3>
                <p className="text-sm text-foreground-500">400-888-9191</p>
                <p className="text-xs text-foreground-400 mt-1">工作日 9:00 - 18:00</p>
              </div>
              <div className="text-center p-8 bg-background-50 rounded-2xl border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">公司地址</h3>
                <p className="text-sm text-foreground-500">北京市朝阳区科技园区91号</p>
                <p className="text-xs text-foreground-400 mt-1">欢迎来访洽谈合作</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于91浏览器',
            description: '91浏览器官方品牌介绍、发展历程、用户口碑与联系方式',
            isPartOf: {
              '@type': 'WebSite',
              name: '91浏览器',
              url: 'https://www.91browser.com',
            },
          }),
        }}
      />
    </>
  );
}